<template>
	<el-button v-bind="$attrs" size="small" @click="$emit('click')">
		{{LocalizePopisostatni('Delete')}}
	</el-button>
</template>


<script>
import { BaseInput } from '#components/dms/common/baseInput';

export default BaseInput.extend({
	name: 'DmsDelete',
});
</script>
